import React, { useEffect, useState } from "react";
import AuthService from "../services/auth.service";
import FeatureService from "../services/feature.service";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Admin = () => {
  const { t } = useTranslation();
  const currentUser = AuthService.getCurrentUser();
  const isAdmin =
    currentUser && (currentUser.roles || []).includes("ROLE_ADMIN");

  // Feature flags gate the "order by table" admin links.
  const [flags, setFlags] = useState({});
  useEffect(() => {
    FeatureService.publicFlags()
      .then((res) => setFlags(res.data || {}))
      .catch(() => setFlags({}));
  }, []);
  const orderByTableOn = !!flags.order_by_table;

  const links = [
    { to: "/create-catalog", title: t("admin.catalogTitle"), desc: t("admin.catalogDesc") },
    { to: "/create-sub-catalog", title: t("admin.subCatalogTitle"), desc: t("admin.subCatalogDesc") },
    { to: "/products", title: t("admin.productsTitle"), desc: t("admin.productsDesc") },
    { to: "/manage-orders", title: t("admin.ordersTitle"), desc: t("admin.ordersDesc") },
    { to: "/admin/reports", title: t("admin.reportsTitle"), desc: t("admin.reportsDesc") },
    { to: "/manage-news", title: t("admin.newsTitle"), desc: t("admin.newsDesc") },
    { to: "/manage-albums", title: t("admin.albumsTitle"), desc: t("admin.albumsDesc") },
    { to: "/upload", title: t("admin.uploadTitle"), desc: t("admin.uploadDesc") },
    // "Order by table" management links — only shown when the feature is on.
    ...(orderByTableOn
      ? [
          { to: "/admin/table", title: t("admin.tablesTitle"), desc: t("admin.tablesDesc") },
          { to: "/manage-table-orders", title: t("admin.tableOrdersTitle"), desc: t("admin.tableOrdersDesc") },
        ]
      : []),
    // Account + feature management are admin-only.
    ...(isAdmin
      ? [
          { to: "/feature", title: t("admin.featuresTitle"), desc: t("admin.featuresDesc") },
          { to: "/manage-users", title: t("admin.usersTitle"), desc: t("admin.usersDesc") },
        ]
      : []),
  ];
  return (
    <div className="container mt-4">
      <h3 className="mb-3">{t("admin.title")}</h3>
      <p className="text-muted">{t("admin.subtitle")}</p>

      <div className="row">
        {links.map((l) => (
          <div className="col-12 col-sm-6 col-lg-3 mb-4" key={l.to}>
            <Link to={l.to} className="text-decoration-none text-reset">
              <div className="card h-100 product-card">
                <div className="card-body">
                  <h5 className="card-title">{l.title}</h5>
                  <p className="card-text small text-muted">{l.desc}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Admin;
